// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PGiftOutlinedSvg from "@fishx/icons-svg/es/asn/PGiftOutlined";
import FishxIcon from '../components/FishxIcon';

var PGiftOutlined = function PGiftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PGiftOutlinedSvg
  }));
};

PGiftOutlined.displayName = 'PGiftOutlined';
export default React.forwardRef(PGiftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PGiftOutlined.js
// module id = 3444
// module chunks = 0